import types from "../types/types";

/** Dashboard / company (or employee-scoped) clockings list */
const clockings = (rows) => {
	return (dispatch) => {
		dispatch({
			type: types.SET_CLOCKINGS,
			payload: Array.isArray(rows) ? rows : [],
		});
	};
};

/**
 * Personal clockings for Veprime Turni.
 * @param {Array} rows
 * @param {string|null} employeeId
 */
export const setMyClockings = (rows, employeeId = null) => {
	return (dispatch) => {
		dispatch({
			type: types.SET_MY_CLOCKINGS,
			payload: {
				rows: Array.isArray(rows) ? rows : [],
				employeeId: employeeId || null,
			},
		});
	};
};

export default clockings;
